import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { System } from '../../../shared-components/System';
import { UserService } from '../../../shared-components/user/user.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-send-test-email',
  templateUrl: './send-test-email.component.html'
})
export class SendTestEmailComponent implements OnInit {

  userEmailAddress = '';
  errors: ErrorList[] = [];
  retValSelected: any = {};
  emailRegexp = System.mailRegexp;
  @ViewChild('EmailAddress', { static: true }) emailRef: ElementRef;
  constructor(
    private userService: UserService,
    private dialogBox: MatDialogRef<SendTestEmailComponent>
  ) { }

  ngOnInit() {
    this.userEmailAddress = _.cloneDeep(this.userService.currentUser.Email);
  }

  validate() {
    this.errors = [];

    if (!this.userEmailAddress || this.userEmailAddress.length == 0 || this.userEmailAddress == '') {
      this.errors.push({
        errorMsg: 'User Email is required',
        fieldRef: this.emailRef,
        fieldName: 'EmailAddress',
      });
    }

    if (this.userEmailAddress && this.userEmailAddress.length > 0 && !this.userEmailAddress.match(this.emailRegexp)) {
      this.errors.push({
        errorMsg: 'Invalid Format',
        fieldRef: this.emailRef,
        fieldName: 'EmailAddress',
      });
    }
  }

  sendTestClick() {
    this.validate();
    if (this.errors.length == 0) {
      this.retValSelected.EmailAddress = this.userEmailAddress;
      this.retValSelected.Message = 'SendTest';
      this.dialogBox.close(this.retValSelected);
    }
  }

  cancelClick() {
    this.retValSelected.Message = 'Cancel';
    this.dialogBox.close(this.retValSelected);
  }
}
